module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/thurston_promo.d0d49ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/thurston_promo.jpg
// module id = uMFS
// module chunks = 1